<template>
  <div class="card-final-container">

    <div class="hide-shares" @click="openShares(false)"></div>

    <div class="questions_container">

      <!-- <p class="result result-pseudo">{{rightAnswersText}}</p> -->

      <p class="result">{{rightAnswersText}}</p>

      <div class="result-text" v-html="mobile && result === 1 ? results['1_m'] : results[result]"></div>

    </div>

    <div class="card card-final">

      <div class="final-illustration" :style="`background-image: url(./results/${result}.png)`"></div>

      <div class="final-text">
        <span>Хороших впечатлений много не&nbsp;бывает! Но&nbsp;иногда их&nbsp;так легко пропустить.</span><br/><br/>Каждый день <span style="color: #D357FF; font-weight: 600">VK&nbsp;Клипы</span> собирают для тебя коллекцию самых удивительных видео со&nbsp;всего мира. Залетай к&nbsp;нам&nbsp;&mdash; и&nbsp;не&nbsp;пропускай легендарные ролики, которые ты&nbsp;будешь показывать ещё внукам!
      </div>

    </div>

    <div class="buttons-container">

      <a target="_blank" href="https://vk.com/clips?choose_interests=1"><ButtonClassic style="text-decoration: none" class="button-classic_final" @click="goPromo()" text="Включай!" ifLink="true"/></a>

      <ButtonClassic class="button-classic_vk" @click="openShares(true)" text=""/>

    </div>


    <transition name="fade">

      <div class="fadeout" v-show="shareOpened"></div>

    </transition>

    <div class="buttons-container buttons-container_shares">

      <transition name="share">

        <div class="share-container" v-show="shareOpened">

          <div class="share share_story" @click="share('story')">Добавить в историю</div>
          <div class="share share_wall" @click="share('wall')">Поделиться на стене</div>
          <div class="share share_cancel" @click="openShares(false)">Отмена</div>

        </div>

      </transition>

    </div>

  </div>
</template>

<script>
import { results, resultsPlain } from '../assets/texts.json'
import ButtonClassic from './ButtonClassic.vue'
import Bridge from '@vkontakte/vk-bridge'

export default {

  name: 'CardFinal',

  props: ['rightAnswers'],

  components: {
    ButtonClassic
  },

  data(){

    return {
      results,
      shareOpened: false
    }

  },

  computed:{
    mobile(){
      if (window.innerWidth > 720) {
        return false
      }

      return true
    },

    result(){

      let res = this.rightAnswers > 2 ? this.rightAnswers > 4 ? 2 : 1 : 0

      return res

    },

    rightAnswersText(){

      let phrase = 'правильных ответов'

      switch (this.rightAnswers) {
        case 1:

          phrase = 'правильный ответ'
          break;

        case 2:
        case 3:
        case 4:

          phrase = 'правильных ответа'
          break;

        case 5:
        case 6:

          phrase = 'правильных ответов'
          break;

      }

      return this.rightAnswers + ' ' + phrase

    }

  },

  methods:{

    goPromo(){
      this.$emit('goPromo')
    },

    openShares(a){
      this.shareOpened = a
    },

    share(arg){

      if (arg === 'wall') {
        Bridge.send("VKWebAppShowWallPostBox",
        {
          message: resultsPlain[this.result],
          attachments: 'https://vk.com/app51467473',
          "link_button": "open_url",
          "link_image": `https://vkclips-dev.for.game/og_${this.result}.jpg`,
        }
        );
      } else {
        Bridge.send("VKWebAppShowStoryBox", {
          attachment: {
            type: 'url',
            url : 'https://vk.com/app51467473',
            text: 'learn_more',
          },
          background_type : 'image',
          url : `https://vkclips-dev.for.game/s_og_${this.result}.jpg`,
        });
      }

        this.$emit('share', 'results_share', {share_type: arg})
    }

  }
}
</script>

<style scoped lang="sass">

.fadeout
  width: 100vw
  height: 100vh
  pointer-events: none
  position: absolute
  background-color: rgba(0, 0, 0, 0.7)

.hide-shares
  width: 100vw
  height: 100vh
  position: absolute

.share
  pointer-events: all
  width: 325px
  height: 52px

  cursor: pointer

  display: flex
  flex-direction: column
  justify-content: center
  align-items: center

  background-color: black
  font-size: 1.3em
  color: white
  font-weight: 400
  font-family: "VK Sans Display"

  border: 1.78155px solid #D357FF

  &:active
    background-color: white
    color: black

  &-container
    position: absolute
    top: 0

  &_cancel
    margin-top: 8px
    border-radius: 15px
    animation-name: cancel
    opacity: 0
    animation-duration: .5s
    animation-delay: .6s
    animation-fill-mode: both
    animation-timing-function: ease-out
    animation-iteration-count: 1

  &_story
    border-radius: 15px 15px 0 0

    &::before
      content: ''
      position: absolute
      left: 5%
      width: 18.68px
      height: 18.68px
      background-size: contain
      background-position: center
      background-repeat: no-repeat
      background-image: url(../assets/img/story.svg)

  &_wall
    border-radius: 0 0 15px 15px

    &::before
      content: ''
      position: absolute
      left: 5%
      width: 18.68px
      height: 18.68px
      background-size: contain
      background-position: center
      background-repeat: no-repeat
      background-image: url(../assets/img/wall.svg)

.card-final
  width: 355px
  height: 311px

  padding: 15px

  background: #FFFFFF
  border-radius: 15px
  margin: 0 auto

.card-final-container
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  height: calc(100% - 100px)
  position: absolute
  top: 0
  margin-top: 50px
  z-index: 10

.questions_container
  position: absolute
  bottom: calc(50% + 150px + 10px)
  animation-name: questions
  animation-duration: .3s
  animation-fill-mode: forwards
  animation-timing-function: ease-out
  animation-iteration-count: 1

@keyframes questions

  0%
    transform: translateY(100px)


  100%
    transform: translateY(0px)

@keyframes cancel

  0%
    opacity: 0


  100%
    opacity: 1


.result
  font-family: "VK Sans Display"
  color: white
  width: fit-content
  margin: 0 auto
  font-size: 1.3em
  line-height: 150%
  font-weight: 300
  text-align: center
  text-transform: uppercase
  background-color: black
  border-radius: 5px
  padding: 0 5px

  &-text
    font-family: "VK Sans Display"
    height: 60px
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    color: white
    font-size: 1.6em
    font-weight: 500
    text-align: center
    min-width: 722px
    line-height: 120%
    margin-bottom: 19px
    margin-top: 6px

.result-text-p
  // background-color: red; border-radius: 5px; padding: 0 5px

.final-illustration
  width: 129.69px
  height: 85px

.final-text
  text-align: center
  margin-top: 10px
  font-weight: 300
  color: black

  span
    color: #A500E0

.buttons-container
  overflow: hidden
  position: absolute
  top: calc(50% + 150px + 30px)
  width: 325px
  display: flex
  justify-content: space-around

  &_shares
    height: 179px
    pointer-events: none

@media (min-width: 420px)
  .share:hover
    background-color: white
    color: black

@media (max-width: 420px)
  .card-final
    width: 80vw
    height: 80vw
    border-radius: 3.75vw

  .questions_container
    bottom: calc(50% + 40vw)

  .buttons-container
    max-width: 85vw
    height: 30vw
    top: calc(50% + 42vw)

    &_shares
      height: 200px
      width: 90vw
      max-width: 90vw

  .share
    max-width: 90vw
    width: 90vw
    height: 6.5vh
    border-radius: 10px
    max-height: 15vw
    font-size: 1.2em

    &_story
      border-radius: 10px 10px 0 0

    &_wall
      border-radius: 0 0 10px 10px

    &_cancel
      margin-top: 1vh

  .result
    font-size: 1.16em
    line-height: 120%

    &-text
      min-width: 90vw
      height: 19vw
      margin-bottom: 3vw
      font-size: 1.4em
      line-height: 120%
      margin-top: 0

</style>
